import styled from 'styled-components';
import wixService from '../../../services/wixService';

export const BasicCategoriesTopBlock = styled.div.attrs(() => ({}))`
  background-color: rgba(0, 0, 0, 0);
  background-color: ${(props) =>
    wixService.getColorByreference(props.design.selectedCategory.color.value)};
  background-color: ${(props) =>
    wixService.getColorValueByComponentName(
      props.styleParams,
      props.design.selectedCategory.color.name,
    )};
  color: ${(props) =>
    wixService.getColorByreference(props.design.categoryOtherText.color.value)};
  color: ${(props) =>
    wixService.getColorValueByComponentName(
      props.styleParams,
      props.design.categoryOtherText.color.name,
    )};

  h2 {
    ${(props) =>
      wixService.getStyleFontByReference(
        props.design.categoryOtherText.font.value,
      )};
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.categoryOtherText.font.name,
      )};
  }
`;
